import React, { useRef } from 'react';
import DataGrid,{ Column, Export, Button as ButtonGrid } from 'devextreme-react/data-grid';
import Nuevo from './Nuevo';
import { store } from '../../services/store';
import uri from '../../utils/uri';
import BlockHeader from '../shared/BlockHeader';
import Title from '../shared/Title';
import CustomButton from '../../components/buttons/CustomButton';
import { useDispatch } from 'react-redux';
import { openDialogScleralClient } from '../../store/scleralsClient/scleralsClientReducer';
import TestNuevo from './TestNuevo';

const Sclerals = ({ clientId }) => {

    const dispatch = useDispatch();

    let dataGrid = useRef();

    const onToolbarPreparing = (e) => {  
        e.toolbarOptions.items.unshift({
            location: 'before',
            widget: 'dxButton',
            options: {
                text: 'Exportar a excel',
                icon:'xlsxfile',
                type:'success',
                stylingMode:"outlined",
                onClick: () =>  dataGrid.current.instance.exportToExcel(false)
            }
        });
    }  

    const reload = () => dataGrid.current.instance.refresh()

    const onRowDblClick = e => openDialog(e.data.id);    

    const openDialog = _id => dispatch(openDialogScleralClient(_id, clientId))
    
    const printCard = id => {

        // const report = urlReport();
        // report.print(`${report.card(id)}`);
        
    }

    const addMenuItems =(e) => {

        if (e.target == "content") {
            
            if (!e.items) e.items = [];
            
            if(e.rowIndex >= 0){

                e.items.push({
                    
                    text: 'Imprimir',
                    icon : 'doc',
                    onItemClick: () => printCard(e.row.data.id)                    
                    
                });
            }
        }

    }

    const title = "Lentes Esclerales";

    return (
        <div>
            <Title title={title} />
            <BlockHeader title={title} >
                <CustomButton
                    type="default"
                    text="Agregar nuevo"
                    icon='plus'                   
                    onClick={()=>  openDialog(0)}
                />
            </BlockHeader>
            <Nuevo reload={reload} clientId={clientId}/>
            <DataGrid
                ref={dataGrid}
                dataSource={store({ uri: uri.scleralsClient(clientId) })}
                selection={{ mode: 'single' }}
                showBorders={true}
                showRowLines={true}
                allowColumnResizing={true}
                allowColumnReordering={true}
                hoverStateEnabled={true}
                rowAlternationEnabled={true}
                onToolbarPreparing={onToolbarPreparing}
                onRowDblClick={onRowDblClick}
                onContextMenuPreparing={addMenuItems}
            >                
                <Export enabled={false} fileName={title} allowExportSelectedData={true} />
                <Column type="buttons">
                    <ButtonGrid name="modificar" text="Ver" onClick={e => openDialog(e.row.data.id)}/>
                </Column>
                <Column dataField="eye" caption='RX' width={100} allowFiltering={false} />               
                <Column dataField="date" caption="Fecha" width={110} dataType="date" format="dd/MM/yyyy" />
                <Column dataField="resumenOd" caption='Item' allowFiltering={false} />
                <Column dataField="observation" allowFiltering={false} />               
            </DataGrid>
        </div>
    );
}

export default Sclerals;
